function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20%,20%,20%)",
      fillOpacity: 1
    },
    d: "M 14.5 47.5 C 13.800781 47.5 13 47.199219 12.398438 46.699219 C 11.199219 45.601562 11.199219 43.699219 12.300781 42.5 L 29.5 24.601562 L 12.300781 5.601562 C 11.199219 4.398438 11.300781 2.5 12.5 1.398438 C 13.699219 0.300781 15.601562 0.398438 16.699219 1.601562 L 37.699219 24.800781 L 16.699219 46.699219 C 16.101562 47.199219 15.300781 47.5 14.5 47.5 Z M 14.5 47.5 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownarrow);
export default __webpack_public_path__ + "static/media/dropdownarrow.01ee8e7020e94860c748dea58179f738.svg";
export { ForwardRef as ReactComponent };